import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login, loginVerify } from "../_redux/authCrud";
import { toast } from "react-hot-toast";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  phone: "",
  password: "",
};

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [showCodeField, setShowCodeField] = useState(false);
  const LoginSchema = Yup.object().shape({
    phone: Yup.string().required("شماره موبایل الزامی میباشد."),
    password: Yup.string().required('رمز عبور الزامی میباشد.'),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();

      if (showCodeField) {
        setTimeout(() => {
          loginVerify(values.code)
              .then(({ data: { token } }) => {
                disableLoading();
                props.login(token);
                toast.success("خوش آمدید");
              })
              .catch((err) => {
                console.log(err);
                setStatus(
                    intl.formatMessage({
                      id: "AUTH.VALIDATION.INVALID_LOGIN",
                    })
                );

                toast.error("خطا هنگام ورود");
              })
              .finally(() => {
                disableLoading();
                setSubmitting(false);
              });
        }, 1000);
      } else {
        setTimeout(() => {
          login(values.phone, values.password)
              .then(({ data: { ok, token } }) => {
                disableLoading();
                if (ok === true) {
                  props.login(token);
                  toast.success("خوش آمدید");
                }
              })
              .catch((err) => {
                console.log(err);
                setStatus(
                    intl.formatMessage({
                      id: "AUTH.VALIDATION.INVALID_LOGIN",
                    })
                );

                toast.error("خطا هنگام ورود");
              })
              .finally(() => {
                disableLoading();
                setSubmitting(false);
              });
        }, 1000);
      }
    },
  });

  return (
      <div className="login-form login-signin" id="kt_login_signin_form">
        {/* begin::Head */}
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">
            <FormattedMessage id="AUTH.LOGIN.TITLE" />
          </h3>
          <p className="text-muted font-weight-bold">
            شماره موبایل خود را وارد کنید
          </p>
        </div>
        {/* end::Head */}

        {/*begin::Form*/}
        <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">{formik.status}</div>
              </div>
          )}

          <div className="form-group fv-plugins-icon-container">
            <input
                placeholder={"شماره موبایل"}
                type={"text"}
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "phone"
                )}`}
                name={"phone"}
                {...formik.getFieldProps("phone")}
            />

            {formik.touched.phone && formik.errors.phone ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.phone}</div>
                </div>
            ) : null}
          </div>
          <div className="form-group fv-plugins-icon-container">
            <input
                placeholder={"رمز عبور"}
                type={"password"}
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "password"
                )}`}
                name={"password"}
                {...formik.getFieldProps("password")}
            />

            {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
            ) : null}
          </div>
          {/*{showCodeField && (*/}
          {/*  <div className="form-group fv-plugins-icon-container">*/}
          {/*    <input*/}
          {/*      placeholder={"کد ارسال شده به موبایل"}*/}
          {/*      type={"text"}*/}
          {/*      className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(*/}
          {/*        "phone"*/}
          {/*      )}`}*/}
          {/*      name={"code"}*/}
          {/*      {...formik.getFieldProps("code")}*/}
          {/*    />*/}

          {/*    {formik.touched.code && formik.errors.code ? (*/}
          {/*      <div className="fv-plugins-message-container">*/}
          {/*        <div className="fv-help-block">{formik.errors.code}</div>*/}
          {/*      </div>*/}
          {/*    ) : null}*/}
          {/*  </div>*/}
          {/*)}*/}
          <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
            <button
                id="kt_login_signin_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            >
              <span>ورود به حساب کاربری</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </form>
        {/*end::Form*/}
      </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
